import { render } from "./commonTemplate.vue?vue&type=template&id=044d085a"
import script from "./commonTemplate.vue?vue&type=script&lang=js"
export * from "./commonTemplate.vue?vue&type=script&lang=js"

import "./commonTemplate.vue?vue&type=style&index=0&id=044d085a&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__